import { useRouter } from 'next/navigation';
import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { setFiles } from '@/features/tool/slices/toolSlice';
import { clearUploadIntent } from '@/features/tool/slices/uploadSlice';
import { RootState } from '@/store';

export const useGlobalUploadHandler = () => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const intent = useAppSelector((state: RootState) => state.upload.intent);

  const handleFiles = async (files: FileList) => {
    if (!intent) return;

    const fileList = new DataTransfer();

    // Copy files and potentially handle arrayBuffer processing if needed for specific cases,
    // but for setFiles, usually File objects are enough.
    // However, keeping consistent with previous patterns (creating new Files) if required.
    // For now, simpler approach or copying if needed.
    // Let's stick to the previous robust method seen in Hero to ensure type/buffer consistency if specific browsers have issues,
    // though usually direct FileList is fine.
    // Given the previous code did explicit Blob recreation, let's keep it simple first
    // and just pass the files if possible, or replicate the loop if that was solving a specific bug.
    // The previous Hero code re-created Files. I will replicate that safety just in case.

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      // Create a fresh file object to ensure it survives correctly through any clone operations
      // though typically Redux non-serializable check is the main thing.
      // We'll just pass them through for now.
      fileList.items.add(file);
    }

    dispatch(setFiles(fileList.files));
    router.push(intent.targetPath);
    dispatch(clearUploadIntent());
  };

  return { handleFiles, intent };
};
